// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import getColorSwatchList from '@tcp/core/src/components/features/browse/PlpTile/views/plpTileHelpers/colorSwatchHelper';
import {
  ColorSwatchesWrapper,
  ColorChipButton,
  ColorChipText,
  ColorChipTextButton,
} from '../styles/ColorSwatches.style';
import SafeComponent from '../../../../../../common/hoc/withErrorBoundary/errorBoundary';

const ColorSwatches = ({
  className,
  handleClick,
  productPartNo,
  TCPSwatches,
  assetHost,
  assetPath,
  swatchImg,
  relatedSwatches,
  tcpColor,
  auxDescription,
  isNewSwatchUrlEnabled,
}) => {
  const relatedSwatchImages = (relatedSwatches && relatedSwatches.split(',')) || [];
  const { colorSwatchList } = getColorSwatchList({
    productPartNo,
    TCPSwatches,
    assetHost,
    assetPath,
    swatchImg,
    relatedSwatchImages,
    tcpColor,
    auxDescription,
    isNewSwatchUrlEnabled,
  });

  const list = colorSwatchList.filter((val, idx) => idx < 4);

  return (
    <ColorSwatchesWrapper className={`${className} color-swatches-wrapper`}>
      {list?.map((colorSwatch) => {
        return (
          <li key={colorSwatch.id}>
            <ColorChipButton
              key={colorSwatch.id}
              type="button"
              title={colorSwatch.name}
              name={colorSwatch.name}
              imageUrl={colorSwatch.imageUrl}
              onClick={() => handleClick(colorSwatch.id)}
            />
          </li>
        );
      })}
      {colorSwatchList.length > 4 && (
        <li key="more-swatches-text">
          <ColorChipTextButton type="button" onClick={() => handleClick(colorSwatchList[0]?.id)}>
            <ColorChipText fontFamily="secondary" fontSize="fs12" component="span">
              {`+${colorSwatchList.length - 4}`}
            </ColorChipText>
          </ColorChipTextButton>
        </li>
      )}
    </ColorSwatchesWrapper>
  );
};

ColorSwatches.propTypes = {
  className: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
  productPartNo: PropTypes.string,
  TCPSwatches: PropTypes.string,
  assetHost: PropTypes.string.isRequired,
  assetPath: PropTypes.string.isRequired,
  swatchImg: PropTypes.string,
  tcpColor: PropTypes.string,
  auxDescription: PropTypes.string,
  relatedSwatches: PropTypes.string,
  isNewSwatchUrlEnabled: PropTypes.bool,
};

ColorSwatches.defaultProps = {
  handleClick: () => {},
  productPartNo: '',
  TCPSwatches: '',
  swatchImg: '',
  tcpColor: '',
  auxDescription: '',
  relatedSwatches: '',
  isNewSwatchUrlEnabled: false,
};

export default SafeComponent(ColorSwatches);
